import LocalizedStrings from 'localized-strings';

import { TeamMembersRequestStatus } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    dateLabel: {
      [TeamMembersRequestStatus.Approved]: 'Approved on',
      [TeamMembersRequestStatus.Canceled]: 'Canceled on',
      [TeamMembersRequestStatus.Completed]: 'Approved on',
      [TeamMembersRequestStatus.Pending]: 'Pending',
      [TeamMembersRequestStatus.Processed]: 'Processed',
      [TeamMembersRequestStatus.Rejected]: 'Rejected on',
    },
    requester: 'Applicant',
    status: 'Status',
    statusLabel: {
      [TeamMembersRequestStatus.Approved]: 'Approved',
      [TeamMembersRequestStatus.Canceled]: 'Canceled',
      [TeamMembersRequestStatus.Completed]: 'Approved',
      [TeamMembersRequestStatus.Pending]: 'Pending',
      [TeamMembersRequestStatus.Processed]: 'Processed',
      [TeamMembersRequestStatus.Rejected]: 'Rejected',
    },
    titles: {
      physicalCard: 'Physical card request',
      virtualCard: 'Virtual card request',
    },
  },
  fr: {
    dateLabel: {
      [TeamMembersRequestStatus.Approved]: 'Approuvée le',
      [TeamMembersRequestStatus.Canceled]: 'Annulée le',
      [TeamMembersRequestStatus.Completed]: 'Approuvée le',
      [TeamMembersRequestStatus.Pending]: 'Pending',
      [TeamMembersRequestStatus.Processed]: 'Processed',
      [TeamMembersRequestStatus.Rejected]: 'Rejetée le',
    },
    requester: 'Demandeur',
    status: 'Statut',
    statusLabel: {
      [TeamMembersRequestStatus.Approved]: 'Approuvée',
      [TeamMembersRequestStatus.Canceled]: 'Annulée',
      [TeamMembersRequestStatus.Completed]: 'Approuvée',
      [TeamMembersRequestStatus.Pending]: 'Pending',
      [TeamMembersRequestStatus.Processed]: 'Processed',
      [TeamMembersRequestStatus.Rejected]: 'Rejetée',
    },
    titles: {
      physicalCard: 'Demande de carte physique',
      virtualCard: 'Demande de carte virtuelle',
    },
  },
} as const);

export default locales;
